import React, { lazy } from "react";
import { Navigate } from "react-router-dom";

const Login = lazy(() => import("../pages/auth/Login"));
const Register = lazy(() => import("../pages/auth/Register"));
const GuestRoute = lazy(() => import("./GuestRoute"));
const ResetPassword = lazy(() => import("../pages/auth/ResetPassword"));
const NewPassword = lazy(() => import("../pages/auth/NewPassword"));

const guestRoutes = [
  {
    path: "/login",
    element: (
      <GuestRoute>
        <Login />
      </GuestRoute>
    ),
  },
  {
    path: "/register",
    element: (
      <GuestRoute>
        <Register />
      </GuestRoute>
    ),
  },
  {
    path: "/reset-password",
    element: (
      <GuestRoute>
        <ResetPassword />
      </GuestRoute>
    ),
  },
  {
    path: "/new-password",
    element: (
      <GuestRoute>
        <NewPassword />
      </GuestRoute>
    ),
  },
  {
    path: "/",
    element: (
      <GuestRoute>
        <Navigate to="/login" replace />
      </GuestRoute>
    ),
  },
];

export default guestRoutes;
